// extracted by mini-css-extract-plugin
export default {"advertDetailContactItem":"c-n_ff","advertDetailContactItem__link":"c-n_fg"};